<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Menu-->
<div class="MainMenu">
	<div class="NameSelect">
		<label style="margin: 0">Sound Name:</label>
		<input class="form-control" type="text" placeholder="ExampleSound.mp3" [(ngModel)]="SoundName" />

		<!-- <label style="margin: 0">Available to:</label>
        <select [disabled]="NotDistrictUser()" class="form-control" [(ngModel)]="SchoolOptionID">
            <option *ngFor="let r of lstSchoolOption" [ngValue]="r.ID">{{r.Desc}}</option>
        </select> -->
	</div>

	<div class="top-Margin">
		<label>Edit Sound File:</label>

		<div class="MainButtons">
			<button [disabled]="loading == true" class="btn btn-primary" (click)="onPlayCurrent()">Play Current Sound</button>
			<button [disabled]="loading == true" class="btn btn-primary" (click)="onPause()">Stop Sound</button>
			<button [disabled]="loading == true" class="btn btn-primary" (click)="onUploadNew()">Upload New File</button>
			<!-- <button [disabled]="loading == true" class="btn btn-primary" (click)="onRecord()">Record New Sound</button> -->
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onEdit()">Update</button>
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="form-group top-Margin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<input id="EditSoundInput" name="EditSoundInput" type="file" accept=".mp3" style="display: none" (change)="onSoundChange($event)" />
